import { atom } from 'jotai';

// rummy链接
export const rummyGameUrlAtom = atom<string>('');
// rummy预览页链接
export const rummyPreviewUrlAtom = atom<string>('');
// rummy是否在rummy Tab页
export const isRummyActiveAtom = atom<boolean>(false);
// rummy是否在游戏中
export const isRummyInGameAtom = atom<boolean>(false);
// rummy是否加载过一次
export const isRummyLoadedOnceAtom = atom<boolean>(false);
// rummy 跳转参数
export const rummySubPageAtom = atom<{
  from?: string;
  subPage: number;
  gameId: string | number;
  matchConfigId?: string | number;
  level?: string | number;
  seatCount?: string | number;
  // 自动报名
  autoPlay?: number;
}>({
  from: '',
  subPage: -1,
  gameId: '',
  matchConfigId: '',
  level: '',
  seatCount: '',
  autoPlay: 0,
});

// 免费次数
export const freeTimesAtom = atom<number>(-1);
